import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from '@mui/material/styles/styled';

const Icon = styled(FontAwesomeIcon)();

export default Icon;